/**
 * deployment-general-edit.js
 */

import React from 'react';
import { parseISO, differenceInMinutes } from 'date-fns';
import { Types } from 'utils/constants';
import { renderForMobileContext } from 'utils/app-context';
import LocationEdit from 'components/location-edit';
import DeploymentEditDate from './deployment-edit-date';
import DeploymentEditCommon from './deployment-edit-common';


export default function DeploymentGeneralEdit(props) {
  const {
    drawerState,
    edit,
  } = props;

  return (
    <>
      {/* date */}
      <DeploymentEditDate {...props} />

      {/* location */}
      <LocationEdit
        locationOptions={edit.options.locations}
        countryOptions={edit.options.countries}
        presetOptions={edit.options.recentCommonValues.location}
        drawerState={drawerState}
        recordType={Types.Record.DEPLOYMENT}
        doAutofill={renderForMobileContext()
          && (
            edit.record.id === 0 
            // PT1-TRACKING-SUCKAGE
            // we use this logic to enable auto-fill instead of auto-filling based on known 
            // tracking coords retrieved on the tracking page. PT2 tracking page will improve.
            || (
              edit.record.caseNumber.startsWith('Mobile Tracking:')
              && !edit.record.location.address1
              && differenceInMinutes(new Date(), parseISO(edit.record.dateCreated)) < 30
            )
          )}
      />

      {/* common fields */}
      <DeploymentEditCommon {...props} />
    </>
  );
}